import React from "react"
import { Link } from "react-router-dom"
import CallRecordingPlayButton from "../../Common/CallRecordingPlayButton"

const DIRECTION_STYLES = {
  incoming: { bg: "#d1fae5", color: "#047857", label: "Incoming" },
  outgoing: { bg: "#dbeafe", color: "#1d4ed8", label: "Outgoing" },
  missed: { bg: "#fef3c7", color: "#b45309", label: "Missed" },
  not_picked: { bg: "#fee2e2", color: "#b91c1c", label: "Not picked" },
}

const CallLogRow = ({ row, index, counter, selectedIds, onToggleSelect }) => {
  const dir = DIRECTION_STYLES[row.direction] || {
    bg: "#f1f5f9",
    color: "#334155",
    label: row.direction,
  }
  const rowNum =
    counter !== "" && counter !== undefined ? Number(counter) + index : index + 1
  const checked = selectedIds.includes(row.id)
  const recordingUrl =
    row.has_recording === false ? null : row.recording_url || null

  return (
    <tr>
      <td>
        <input
          type="checkbox"
          name="chk"
          value={row.id}
          checked={checked}
          onChange={e => onToggleSelect(row.id, e.target.checked)}
        />
      </td>
      <td>{rowNum}</td>
      <td>
        <strong>{row.staff_name || "—"}</strong>
      </td>
      <td>{row.contact_name || "—"}</td>
      <td className="font-monospace">{row.phone_number || "—"}</td>
      <td>
        <span
          className="badge"
          style={{
            backgroundColor: dir.bg,
            color: dir.color,
            fontWeight: 600,
          }}
        >
          {dir.label}
        </span>
      </td>
      <td>{row.duration_formatted || "00:00:00"}</td>
      <td style={{ whiteSpace: "nowrap" }}>{row.started_at || "—"}</td>
      <td style={{ whiteSpace: "nowrap" }}>
        {row.days_since_last_call != null ? (
          <span
            className="badge"
            style={{
              backgroundColor:
                row.days_since_last_call >= 30
                  ? "#fee2e2"
                  : row.days_since_last_call >= 10
                  ? "#fef3c7"
                  : "#e2e8f0",
              color:
                row.days_since_last_call >= 30
                  ? "#b91c1c"
                  : row.days_since_last_call >= 10
                  ? "#b45309"
                  : "#475569",
              fontWeight: 600,
            }}
          >
            {row.days_since_last_call} day
            {row.days_since_last_call === 1 ? "" : "s"}
          </span>
        ) : (
          "—"
        )}
      </td>
      <td>
        {row.lead_id ? (
          <Link
            to={`/leads?id=${row.lead_id}&global_search=1`}
            className="text-primary fw-semibold"
          >
            {row.lead_name || `Lead #${row.lead_id}`}
          </Link>
        ) : (
          "—"
        )}
      </td>
      <td>
        <CallRecordingPlayButton
          url={recordingUrl}
          status={row.recording_status}
        />
      </td>
      <td>
        <span className="text-muted small">{row.conversation_notes || "—"}</span>
      </td>
    </tr>
  )
}

export default CallLogRow
